import { INVOICES_PATH, PAYMENT_SETTINGS_PATH } from "../../billing/constant";
import { PLUS_DASHBOARD_PATH } from "../../subscription/constant";

/**
 * Where a screen's back arrow goes when nothing of the app is behind it (the
 * screen was opened by a link): its parent screen. Each is a route in
 * apps/luce-fe/src/app (back-to.test.ts checks).
 */
export const BACK_TO = {
  home: "/",
  notifications: "/notifications",
  profile: "/profile",
  accountInfo: "/profile/account-info",
  addresses: "/profile/addresses",
  contacts: "/profile/contacts",
  giftCards: "/profile/gift-card",
  packages: "/profile/packages",
  creditAccount: "/profile/credit-account",
  mainCredit: "/profile/credit-account/general",
  massageCredit: "/profile/credit-account/massage",
  beautyCredit: "/profile/credit-account/beauty",
  petCredit: "/profile/credit-account/pet",
  invoices: INVOICES_PATH,
  payment: PAYMENT_SETTINGS_PATH,
  serviceProfiles: "/profile/service-profile",
  plus: PLUS_DASHBOARD_PATH,
} as const;
